export default __webpack_public_path__ + "static/media/Ultraman_00.df8e9b25.png";